import styled from "styled-components"
import React from "react"

import Button from "./Button"
import CommentRectSVG from "../../Svg/CommentRect"
import { mediaMin, mediaMax } from "../../../utils/breakpoints"

interface ContactButtonProps {
  className?: string
  onClick?: () => void
  active: boolean
  myDisabled?: boolean
}

export default ({
  className,
  onClick,
  active,
  myDisabled,
}: ContactButtonProps) => {
  return (
    <ContactButton
      type="button"
      className={className}
      onClick={onClick}
      icon={
        <CommentRectSVG
          fill="none"
          stroke="#303030"
          width="21px"
          className="icon"
        />
      }
      text="Hafa samband"
      active={active}
      myDisabled={myDisabled}
    />
  )
}

const ContactButton = styled(Button)``
